import React, { useState } from 'react';
import { Container, TextField } from '@mui/material';

export default function NoteField({
    note,
    setNote,
    maxLength = 150,
    label = "Note"
}) {
    const [error, setError] = useState("");

    const handleChange = (event) => {
        const value = event.target.value;

        if (value.length <= maxLength) {
            setNote(value);
            setError("");
        } else {
            setError(`Testo troppo lungo (max ${maxLength} caratteri)`);
        }
    };

    return (
        <Container>
            <TextField
                label={label}
                multiline
                minRows={3}
                variant="outlined"
                fullWidth
                margin="normal"
                value={note}
                onChange={handleChange}
                error={!!error}
                helperText={error || `${note.length}/${maxLength}`}
            />
        </Container>
    );
}
